import moment from 'moment';

import { setConfigChart } from './helperLine';
import { setConfigChartBar } from './helperBar';
import { setConfigChartPie } from './helperPie';
import { setConfigChartBubble } from './helperBubble';
import { setConfigChartGauge } from './helperGauge';
import { setConfigChartScatter } from './helperScatter';
import { setConfigChartHeatmap } from './helperHeatmap';
import { setConfigChartTreemap } from './helperTreemap';
import { setConfigChartSunburst } from './helperSunburst';
import { setConfigChartMap } from './helperMap';

import { findTypeCheckByUrl, reformatNumber } from 'src/app/libs/helpers/data-visualization-helper';

import * as formatNumberIdFile from 'src/assets/data/formatNumberID.json';
import * as collorPalleteFile from 'src/assets/data/color_palette.json';

import { setConfigChartBigNumber } from './helperBigNumber';
import { setConfigMarkup } from './helperMarkup';
import { setConfigChartTable } from './helperTable';
import { setConfigChartFilterBox } from './helperFilterBox';
import { setConfigPivotTable } from './helperPivotTable';
import { setConfigChartDirectedForce } from './helperDirectedForce';
import { setConfigChartWordcloud } from './helperWordcloud';
import { setConfigTableComparison } from './helperTableComparison';
import { setConfigChartHistogram } from './helperHistogram';
import { setConfigSparkline } from './helperSparkline';
import { setConfigSparklineTable } from './helperSparklineTable';
import { setConfigNumericalFilter } from './helperNumericalFilter';

declare var d3: any;
const colorPaletteJsonFile: any = (collorPalleteFile as any).default;

let colorPaletteVar = [];
for (var i = 0; i < colorPaletteJsonFile.length; i++) {
  colorPaletteVar['palette' + (i + 1)] = colorPaletteJsonFile[i];
}

export const NULL_STRING_ID = '!<@#@#PdSNu11VaL!!';
export const NULL_REPLACE_STRING = "";

export const CHART_CONSTANTS = {
  general: { collorPalette: colorPaletteVar },
};

export const chartGrid = { left: '10%', top: '20%', bottom: '16%', right: '10%' };

export const tooltipObj = {
  trigger: 'item',
  textStyle: { fontSize: 10 },
};

const axisObj = {
  nameLocation: 'center',
  nameGap: 40,
  splitLine: { lineStyle: { type: 'dashed' } },
  axisLine: { show: true },
  scale: true,
};

export const yAxisObj = { type: 'value', ...axisObj };
export const xAxisObj = { type: 'category', ...axisObj };

export const axisFormater = (value: any, data: any, format?: string) => {
  const formatNumber = format || '';
  let formaterNumber = formatNumberIdFile;
  const locale = data.form_data.format_number_id === 'true' || data.form_data.format_number_id === true ? 'ID' : 'EN';
  d3.formatDefaultLocale(formaterNumber[locale]);
  return reformatNumber(value, formatNumber, data, d3);
};

export const generateLegend = (data: any, type: string, legendData: any = false) => {
  let result: any;
  const typePage = findTypeCheckByUrl();

  const legendWidth = Number(data.form_data.legend_width);

  result = {
    data: legendData || false,
    type: data.form_data.legend_type,
    textStyle: { color: '#808080', fontSize: 10 },
    pageTextStyle: { color: '#808080' },
    width: legendWidth,
    orient: data.form_data.legend_orient,
    show: typePage === 'app_preview' ? checkSessionLegend(data.form_data.show_legend) : data.form_data.show_legend
  };

  switch (data.form_data.legend_position) {
    case 'bottom':
      result.top = 'bottom';
      break;
    case 'left':
      result.left = 'left';
      break;
    case 'right':
      result.right = 'right';
      break;
    case 'right_center':
      result.right = 'right';
      result.top = 'center';
      break;
    case 'left_center':
      result.left = 'left';
      result.top = 'center';
      break;
    default:
      result.top = 'top';
      break;
  }
  return result;
};

export const generateLegendOrder = (data: any, legend?:any) => {
  let result: any;
  const typePage = findTypeCheckByUrl();
  const legendWidth = Number(data.form_data.legend_width);

  const legend_order = data.form_data.legend_order.map((_legend: string) => {
    if (_legend == NULL_STRING_ID) {
      return NULL_REPLACE_STRING;
    }

    return _legend;
  });

  result = {
    data: legend ? legend : legend_order,
    type: data.form_data.legend_type,
    textStyle: { color: '#808080', fontSize: 10 },
    pageTextStyle: { color: '#808080' },
    width: legendWidth,
    orient: data.form_data.legend_orient,
    show: typePage === 'app_preview' ? checkSessionLegend(data.form_data.show_legend) : data.form_data.show_legend
  };

  switch (data.form_data.legend_position) {
    case 'bottom':
      result.top = 'bottom';
      break;
    case 'left':
      result.left = 'left';
      break;
    case 'right':
      result.right = 'right';
      break;
    case 'right_center':
      result.right = 'right';
      result.top = 'center';
      break;
    case 'left_center':
      result.left = 'left';
      result.top = 'center';
      break;
    default:
      result.top = 'top';
      break;
  }
  return result;
};

export const getConfigChart = async (
  data: any,
  typeChart: string,
  service: any,
  explore: any,
  sanitizer?: any,
  sort?: any,
  zoom?: any,
  centroid?: any,
  selectedValue?: any,
  filterId?: any
) => {
  if (typeChart === 'sunburst') {
    // reformat date
    if (data.data.length > 0) {
      for (var i = 0; i < data.data[0].children.length; i++) {
        let value = data.data[0].children[i];
        for (var prop in value) {
          if (Object.prototype.hasOwnProperty.call(value, prop)) {
            if (typeof value[prop] === 'string') {
              if (!isNaN(Date.parse(value[prop]))) {
                let formatedDate = moment(new Date(value[prop])).format('DD/MM/YYYY');
                value[prop] = formatedDate;
              }
            }
          }
        }
      }
    }
  }
  const colorPalette = data?.form_data?.colorpickers?.map((value) => value.colorpicker);
  switch (typeChart) {
    case 'dist_bar':
    case 'horizontal_bar':
      return setConfigChartBar(data, explore, selectedValue, colorPalette);
    case 'line':
    case 'dual_line':
      return setConfigChart(data, explore, selectedValue, filterId, colorPalette);
    case 'pie':
      return setConfigChartPie(data, explore, selectedValue);
    case 'bubble':
      return setConfigChartBubble(data, data?.form_data?.colorpickers);
    case 'gauge':
      return setConfigChartGauge(data);
    case 'predictive':
    case 'scatter':
      return setConfigChartScatter(data);
    case 'heatmap':
      return setConfigChartHeatmap(data);
    case 'treemap':
      return setConfigChartTreemap(data, explore, colorPalette);
    case 'sunburst':
      return setConfigChartSunburst(data, colorPalette);
    case 'country_map':
    case 'map':
      return await setConfigChartMap(data, explore, service, zoom, centroid);
    case 'big_number_total':
      return setConfigChartBigNumber(data);
    case 'markup':
      return setConfigMarkup(data, sanitizer);
    case 'table':
    case 'preview':
      return setConfigChartTable(data, sort, typeChart);
    case 'pivot_table':
      return setConfigPivotTable(data, sanitizer);
    case 'filter_box':
      return setConfigChartFilterBox(data);
    case 'directed_force':
      return setConfigChartDirectedForce(data, explore, colorPalette);
    case 'word_cloud':
      return setConfigChartWordcloud(data, colorPalette);
    case 'table_comparison':
      return setConfigTableComparison(data);
    case 'histogram':
      return setConfigChartHistogram(data);
    case 'sparkline':
      return setConfigSparkline(data, explore, selectedValue);
    case 'sparkline_table':
      return setConfigSparklineTable(data, sort);
    case 'numerical_filter':
      return setConfigNumericalFilter(data);
  }
};

export const countWidthChar = (str: string): number => {
  let lowercaseCount = 0;
  let uppercaseCount = 0;
  let numberCount = 0;
  let characterCount = 0;
  let spaceCount = 0;
  let total = 0;

  for (let i = 0; i < str.length; i++) {
    const char = str[i];

    switch (true) {
      case (char >= 'a' && char <= 'z'):
        lowercaseCount++;
        break;

      case(char >= 'A' && char <= 'Z'):
        uppercaseCount++;
        break;
      
      case (char >= '0' && char <= '9'):
        numberCount++;
        break;

      case (char === ' '):
        spaceCount++;
        break;
    }

    characterCount++;
  }

  total = (lowercaseCount * 5) + (uppercaseCount * 10) + (numberCount * 9) + (spaceCount * 5);

  return total;
}

export const getResponsiveOptions = (chartWidth: number) => {
  switch (true) {
    case (chartWidth >= 1200):
      return { 
        width: 300,
        gap: 20,
        slice: 30,
      };

    case (chartWidth >= 768 && chartWidth < 1200):
      return {
        width: 200,
        gap: 20,
        slice: 26,
      }; 

    case (chartWidth >= 576 && chartWidth < 768):
      return { 
        width: 120,
        gap: 20,
        slice: 21,
      };

    case (chartWidth >= 320 && chartWidth < 576):
      return {
        width: 80,
        gap: 18,
        slice: 8,
      };

    case (chartWidth >= 180 && chartWidth < 320):
      return {
        width: 40,
        gap: 10,
        slice: 4,
      };

    default:
      return {
        width: 30,
        gap: 4,
        slice: 0,
      };
  }
}

export const checkSessionLegend = (value) => {
 return sessionStorage.getItem('legend') ? (sessionStorage.getItem('legend') === 'default' ? value : sessionStorage.getItem('legend') === 'no_legend' ? false : true) : value
}

export const checkSessionLabel = (value) => {
 return sessionStorage.getItem('label') ? (sessionStorage.getItem('label') === 'default' ? value : sessionStorage.getItem('label') === 'no_label' ? false : true) : value
}